<div class="add-new">
  <span class="btn-circle" (click)="openModal(category_create)">
    <i class="ti-plus text-info"></i>
  </span>
</div>
<ng-template #category_create>
  <form [formGroup]="modalForm" class="category_create">
    <div class="modal-body">
      <input
        *ngFor="let item of propertiesArray; let i = index"
        type="type"
        [formControlName]="item"
        [placeholder]="placeholderArray[i]"
        tooltip="This field is required and must be longer then 1 letter"
        [isOpen]="canShowFormControlError(item)"
        container="body"
        containerClass="error-tooltip"
        placement="bottom"
        triggers=""
      />
      <div class="d-flex justify-content-between m-b-10 modal-checkbox">
        <div *ngFor="let checkboxControl of checkBoxesControls | slice: 1; let i = index" class="m-r-20 checkbox-item">
          <span
            *ngIf="getQuestionCategoryTypeByIndex(i) == questionCategoryType.ForProjectTeam"
            [feature]="feature.pme"
          >
            <input
              [name]="i"
              type="checkbox"
              [formControl]="checkboxControl"
              [checked]="checkboxControl.value"
              [id]="i"
              class="with-gap"
            />
            <label class="answer-text" [for]="i">{{ getCheckboxLabel(i) }}</label>
          </span>
          <span *ngIf="getQuestionCategoryTypeByIndex(i) != questionCategoryType.ForProjectTeam">
            <input
              [name]="i"
              type="checkbox"
              [formControl]="checkboxControl"
              [checked]="checkboxControl.value"
              [id]="i"
              class="with-gap"
            />
            <label class="answer-text" [for]="i">{{ getCheckboxLabel(i) }}</label>
          </span>
        </div>
      </div>
      <div class="btn-modal">
        <span #saveButton (click)="onSave()">Yes</span>
        <span (click)="modalRef.hide()" [class.disabled]="isOnSaving">Cancel</span>
      </div>
    </div>
  </form>
</ng-template>
<ng-template #popTemplate>This field is required and must be longer then 1 letter</ng-template>
